import React, { useEffect, useRef, useState } from 'react';
import './css/ResizableGrid.css'; 

const ResizableGrid = ({ res, coordx,coordy }) => {
  const column = 6;
  const gridContainerRef = useRef(null); // 创建一个ref来引用grid-container
  const gridContainerRef1 = useRef(null);
  const [gridWidth, setGridWidth] = useState(0); // 用于存储grid-container的宽度
  const [gridHeight, setGridHeight] = useState(0);

  useEffect(() => {
    // 获取grid-container的宽度并更新state
    if (gridContainerRef.current,gridContainerRef1.current) {
      const width = gridContainerRef.current.offsetWidth;
      const height = gridContainerRef1.current.offsetHeight;
      setGridHeight(height)
      setGridWidth(width);
    }
  }, [coordx]);

  const gridItems = Array.from({ length: column }, (_, colIndex) => {
    const cellWidth = (gridWidth / column) * (colIndex); // 计算每个网格的宽度
    console.log(cellWidth);
    const cellValue = (coordx*res/gridWidth*cellWidth).toFixed(2); // 根据分辨率计算数值并保留两位小数
    
    return (
      <div
        className="grid-column"
        key={`column-${colIndex}`}
        // style={{ width: `${cellWidth}px` }}
      >
        
        <span className="span">{`${cellValue}mm`}</span>
      </div>
    );
  });

  const gridRow = Array.from({ length: column }, (_, colIndex) => {
    const cellHeight = (gridHeight / column) * (colIndex); // 计算每个网格的高度
    var cellValue = (coordy*res/gridHeight*cellHeight).toFixed(2);// 根据分辨率计算数值并保留两位小数
    return (
      <div
        className="grid-row"
        key={`row-${colIndex}`}
        // style={{ height: `${cellHeight}px` }}
      >
        <span className="span1">{colIndex==0?'':`${cellValue}mm`}</span>
      </div>
    );
  });

  return (
    <div>
      <div className="grid-container" ref={gridContainerRef}>
        {gridItems}
      </div>
      <div className="grid-container1" ref={gridContainerRef1}>
        {gridRow}
      </div>
    </div>
  );
};

export default ResizableGrid;
